import React, {  useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "../assets/css/FenetreDescription.css";
// import "../assets/css/legende.css";
import { Grid } from "@mui/material";
import Button from '@mui/material/Button';

import pictoFormationPluridisciplinaire from "../assets/pictos/Picto e-sport_Formation pluridisciplinaire.svg"
import pictoStudio from "../assets/pictos/Picto e-sport_Studio.svg"
import pictoCentreEsport from "../assets/pictos/Picto e-sport_Centre esport.svg"
import pictoFormationEsport from "../assets/pictos/Picto e-sport_Formation esport.svg"
import pictoDistributeur from "../assets/pictos/Picto e-sport_Distributeur.svg"
import pictoFormationInformatique from "../assets/pictos/Picto e-sport_Formation informatique.svg"
import pictoEditeur from "../assets/pictos/Picto e-sport_Editeur.svg"


function Legende() {

    const [afficher, setAfficher] = useState(false);
    
  return (
    <>
        <Button id="legende__bouton__affichage" onClick={() => setAfficher(true)} variant="outlined">Afficher la légende</Button>


        {afficher&&
        <>
            <div className="FenetreDescription_fond "></div>

            <div className="FenetreDescription_fenetre legende__scroll ">

                <div className="legende__bouton__affichage--fermeture">
                    <CloseIcon onClick={() => setAfficher(false)} />
                </div>

                <div className="FenetreDescription_contenu ">
                    <Grid container className=""  id="conteneur_legende">
                        <div>
                            <h2>Entreprises</h2>
                            <div>
                                <img src={pictoCentreEsport}/>
                                <p><b>Centres esport :</b> centres dédiés à la pratique de l’esport, avec ou sans équipes référencées.</p>
                            </div>
                            <div>
                                <img src={pictoDistributeur}/>
                                <p><b>Distributeurs :</b> revendeurs de matériels pour professionnels dans le jeu vidéo et le esport.</p>
                            </div>
                            <div>
                                <img src={pictoStudio}/>
                                <p><b>Studios :</b> chargés de la conception de jeux vidéos.</p>
                            </div>
                            <div>
                                <img src={pictoEditeur}/>
                                <p><b>Editeurs :</b> chargés de la valorisation du jeu (marketing, communication). Ils peuvent également concevoir le jeu.</p>
                            </div>
                        </div>
                        <div>
                            <h2>Formations</h2>
                            <div>
                                <img src={pictoFormationEsport}/>
                                <p><b>Formations esport :</b> formations dédiées au esport (événementiel, marketing, coaching…)</p>
                            </div>
                            <div>
                                <img src={pictoFormationInformatique}/>
                                <p><b>Formations informatique :</b> formations spécialisées au développement informatique avec une ou plusieurs options proposées en gaming.</p>
                            </div>
                            <div>
                                <img src={pictoFormationPluridisciplinaire}/>
                                <p> <b>Formations pluridisciplinaires : </b>formations du numérique, de l’animation ou du design avec un ou plusieurs cursus en création de jeu vidéo</p>
                            </div>
                        </div>
                    </Grid>
                </div>

            </div>
        </>
        }
    </>
  );
}

export default Legende;
